import {createContext} from "react"

export const alertContext = createContext({
  message: null,
  type: "",
  duration: 2000,
  isVisible: false,
  setError: (e: any) => {},
  setMessage: (e: any, onClose?: () => void) => {},
})